<template>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h3>Add trip</h3>
            </div>

        </div>
        <template v-if="initializintErrors">
            <feedback
                    :error="initializintErrors"
            />
        </template>
        <template v-if="initializing">
            <p>Initializing....</p>
        </template>
        <template v-if="!initializing && !initializintErrors">
            <div class="row">
                <div class="col-sm-12">
                    <feedback
                            :info="trip.info"
                            :error="trip.error"/>
                </div>
            </div>
            <template v-if="!trip.info">
                <div class="row">
                    <div class="col-sm-12">
                        <AddWayPoint :way-point="trip.currentWayPoint"
                                     :update-way-point="updateWayPoint"
                                     :add-way-point="addWayPoint"/>
                    </div>
                </div>
                <div>
                    <WayPointsTable v-bind:way-points="trip.wayPoints"
                                    v-bind:editable="true"
                                    v-bind:delete-way-point="tripDeleteWayPoint"/>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Driver emails (Comma separated): </label>
                            <input type="text" class="form-control" v-bind:class="{'is-invalid': trip.tripErrors.driversEmails}"
                                   name="driversEmails"
                                   :value="trip.driversEmails"
                                   @input="onTripChange">
                            <div class="invalid-feedback" v-if="trip.tripErrors.driversEmails">
                                {{trip.tripErrors.driversEmails}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Note:</label>
                            <textarea class="form-control" v-bind:class="{'is-invalid': trip.tripErrors.notes}"
                                      v-bind:value="trip.notes"
                                      name="notes"
                                      @input="onTripChange"></textarea>
                            <div class="invalid-feedback" v-if="trip.tripErrors.notes">
                                {{trip.tripErrors.notes}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <button type="button" class="btn btn-secondary"
                                    v-on:click="cancel">Cancel</button>
                            <button  class="btn btn-primary ml-2" v-if="!trip.submitting"
                                     v-on:click="submit">Submit</button>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="trip.info">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <button type="button" class="btn btn-secondary"
                                    v-on:click="cancel">Done</button>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>

    import {mapState, mapActions} from "vuex";
    import WayPointsTable from "./WayPointsTable";
    import AddWayPoint from "./AddWayPoint";
    import Feedback from "../commons/feedback";


    export default {
        name: "editable_trip",
        components: {Feedback, AddWayPoint, WayPointsTable},
        computed: {
            ...mapState({
                trip: state => state.trip,
                initializing: state => state.globalStore.initializing,
                initializintErrors: state => state.globalStore.initializintErrors,
            }),
        },
        methods: {
            ...mapActions( [
                "updateTrip",
                "updateWayPoint",
                "addWayPoint",
                "submitTrip",
                "tripOnValidate",
                "tripDeleteWayPoint",
            ]),
            onTripChange(event) {
                this.updateTrip({name: event.target.name, value: event.target.value})
            }
            ,
            "submit": function(){

                this.tripOnValidate();

                if(this.trip.error){
                    return;
                }

                this.submitTrip();
            },
            "cancel": function() {
                this.$router.push({path: "/"})
            }
        }
    }
</script>

<style scoped>

</style>
